import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSearch }  from '@fortawesome/fontawesome-pro-regular';
import { UsefPersonSearchService } from '../../../providers/usef-person-search.service';
import { Usef_person } from '../../../models/usef/usef_person';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-usef-person-search',
  templateUrl: './modal-usef-person-search.component.html',
styleUrls:  ['./modal-usef-person-search.component.css']
})
export class ModalUsefPersonSearchComponent extends SmsAbstractAppPage implements OnInit {

	faSearch = faSearch;
	search_results: Usef_person[] = [];
	person_selected$: EventEmitter<Usef_person> = new EventEmitter<Usef_person>();
	selected_state: string = "";
	entity_type: string = 'I';
	entity_name_type: string = 'O';

  constructor(public activeModal: NgbActiveModal, private usefPersonSearchService: UsefPersonSearchService) {
  	super();
  }

  ngOnInit() {
  }

  handleUsefIdSearch(search_term: string){
    this.usefPersonSearchService.getById(search_term, this.entity_type).then(search_results => {
      this.search_results = search_results;
      this.scrollToResults();
    }).catch(error => {
      this.handleError(error);
    });
  }

  handleUsefNameSearch(first_name: string, last_name: string, city: string){
    this.usefPersonSearchService.getByName(first_name, last_name, city, this.selected_state).then(search_results => {
      this.search_results = search_results;
      this.scrollToResults();
    }).catch(error => {
      this.handleError(error);
    });
  }

  handleUsefEntityNameSearch(name: string){
    this.usefPersonSearchService.getByEntityName(name).then(search_results => {
      this.search_results = search_results;
      this.scrollToResults();
    }).catch(error => {
      this.handleError(error);
    });
  }

  private scrollToResults() {
    setTimeout(() => {
      const el = document.getElementById('list-search-results');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  }

	handleSelect(usef_person: Usef_person){
		this.person_selected$.emit(usef_person);
	}

}
